import styled from "styled-components";

export const LeafletMapWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: grid;
  min-width: 400px;
`;
